module.exports = __webpack_public_path__ + "static/media/pousada_4.6664d364.jpg";